

class FiltersMe extends HTMLElement {
    constructor() {
        super()
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
        this.init()
    }
    init(){
        
    }

    // fake i am not able to find this.
    static toggleActiveFacets(disable = true) {
        document.querySelectorAll('.js-facet-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
        FiltersMe.searchParamsPrev = searchParams;
        const sections = FiltersMe.getSections();
        const countContainer = document.getElementById('ProductCount');
        const countContainerDesktop = document.getElementById('ProductCountDesktop');
        document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
        if (countContainer){
            countContainer.classList.add('loading');
        }
        if (countContainerDesktop){
            countContainerDesktop.classList.add('loading');
        }

        sections.forEach((section) => {
            const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
            const filterDataUrl = element => element.url === url;

            FiltersMe.filterData.some(filterDataUrl) ?
            FiltersMe.renderSectionFromCache(filterDataUrl, event) :
            FiltersMe.renderSectionFromFetch(url, event);
        });

        if (updateURLHash) FiltersMe.updateURLHash(searchParams);
    }
        
    onActiveFilterClick(event) {
        event.preventDefault();
        FiltersMe.toggleActiveFacets();
        const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        FiltersMe.renderPage(url);
    }
}
FiltersMe.filterData = [];
FiltersMe.searchParamsInitial = window.location.search.slice(1);
FiltersMe.searchParamsPrev = window.location.search.slice(1);
customElements.define('filters-me', FiltersMe);